import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class NavMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: true,
            userData: JSON.parse(localStorage.getItem('userData'))

        };
        if (!this.state.userData || (this.state.userData && this.state.userData.userType !== "admin")) {
            this.props.history.push({
                pathname: "/admin",
            });
        }

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.subMenu = this.subMenu.bind(this)
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    }
    subMenu = (menu) => {
        this.props.history.push({
            pathname: menu,
        });

    }

    toggle() {
        $('#sidebar').toggleClass('active');
    }

    render() {

        return (
            <nav className="navbar navbar-expand-lg navbar-light bg-light custom-navbar">
                <div className="container-fluid">

                    <button type="button" id="sidebarCollapse" className="hamburger-btn is-closed" onClick={this.toggle}>
                        <div>
                            <span className="hamb-top"></span>
                            <span className="hamb-middle"></span>
                            <span className="hamb-bottom"></span>
                        </div>
                    </button>
                    <button className="btn btn-dark d-inline-block d-lg-none ml-auto" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i className="fas fa-align-justify"></i>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                       {/* <ul className="nav navbar-nav ml-auto">
                            <li className="nav-item active">
                                <a className="nav-link" href="#">Page</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#">Page</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#">Page</a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" href="#">Page</a>
                            </li>
                        </ul>*/}
                    </div>
                </div>
            </nav>
        );
    }
}




function mapStateToProps(state) {
    return {
        fields: state.home.response.data
    };
}
export default withRouter(connect(mapStateToProps, {

})(NavMenu));
//export default SubMenu;


// WEBPACK FOOTER //
// ./src/components/Admin/sidebar/navBar.js